import { insertSuggestNodeCommand } from "../../core/suggest/suggest";
import { SlashCommandGroup } from "../../core/types";
export const codeCommandSpec = {
    label: `Insert Code Block`,
    description: `Display code with syntax highlight`,
    group: SlashCommandGroup.Advanced,
    icon: "is-code",
    shortcut: "C",
    command: insertSuggestNodeCommand({ type: "code_block" }, 1),
};
